import { render, staticRenderFns } from "./AdminModal.vue?vue&type=template&id=2d8869d8&scoped=true&"
import script from "./AdminModal.vue?vue&type=script&lang=ts&"
export * from "./AdminModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d8869d8",
  null
  
)

export default component.exports